module.exports = __webpack_public_path__ + "img/pickup.9e0cf189.svg";